import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import useInventory from "../../../services/Inventory/useInventory";
import { GlobalContext } from "../../../Context/GlobalContext";

const AddVariantItemModal = ({ show, onHide, itemId, itemName, onSuccess }) => {
  const { addItemVariant } = useInventory();
  const { userID } = useContext(GlobalContext);

  const [form, setForm] = useState({
    variation: "",
    price: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      setForm({
        variation: "",
        price: "",
      });
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.variation.trim() || !form.price) {
      toast.error("All fields are required");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        userid: userID,
        itemId: String(itemId),
        price: String(form.price),
        variation: form.variation,
        variationId: "",
      };

      const success = await addItemVariant(payload);

      if (success) {
        toast.success("Variant added successfully");
        onSuccess && onSuccess();
        onHide();
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <>

    <div className="fixed inset-0 z-50 flex items-center justify-center montserrat-font-1">

      {/* BACKDROP */}
      <div
        className="absolute inset-0 bg-black/40 montserrat-font-1"
        onClick={onHide}
      />

      {/* MODAL */}
      <div className="relative bg-white w-full max-w-md rounded-lg shadow-lg z-10 montserrat-font-1">

        {/* HEADER */}
        <div className="flex justify-between items-center px-5 py-3 border-b montserrat-font-1">
          <h2 className="text-sm font-semibold text-gray-700">
            Add Variant
            {itemName && (
              <span className="text-gray-500 ml-1 text-xs">
                · {itemName}
              </span>
            )}
          </h2>

          <button onClick={onHide} className="text-gray-500 text-lg">
            ✕
          </button>
        </div>

        {/* BODY */}
        <form onSubmit={handleSubmit} className="p-5 space-y-4 montserrat-font-1">

          <div>
            <label className="text-xs font-semibold text-gray-600">
              Variation Name / Label
            </label>
            <input
              type="text"
              placeholder="Eg. Small, Medium, Large"
              value={form.variation}
              onChange={(e) =>
                setForm({ ...form, variation: e.target.value })
              }
              className="w-full mt-1 border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-green-500 outline-none"
            />
          </div>

          <div>
            <label className="text-xs font-semibold text-gray-600">
              Price
            </label>
            <input
              type="number"
              placeholder="Eg. 199"
              value={form.price}
              onChange={(e) =>
                setForm({ ...form, price: e.target.value })
              }
              className="w-full mt-1 border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-green-500 outline-none"
            />
          </div>

          <p className="text-xs text-gray-500 montserrat-font-2">
            <span className="text-red-500 font-semibold">Note:</span>{" "}
            <code>variationId</code> will be sent empty; backend will treat this as a new price variation for this item.
          </p>

          {/* FOOTER */}
          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={onHide}
              className="px-4 py-1.5 text-sm border rounded-md text-gray-600"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="px-4 py-1.5 text-sm bg-green-500 text-white rounded-md hover:bg-green-600"
            >
              {loading ? "Saving..." : "Save Variant"}
            </button>
          </div>

        </form>
      </div>
    </div>
    </>
  );
};

export default AddVariantItemModal;